import { Action } from '@ngrx/store';
export enum OfferActionTypes {
  DEFAULT_OFFER_STATE ='DEFAULT_OFFER_STATE',
  VIEW_OFFER = 'VIEW_OFFER',
  OFFER_SUCCESS  = 'OFFER_SUCCESS',
  OFFER_FAILURE  = 'OFFER_FAILURE',
  OFFER_STATUS_CHANGE = 'OFFER_STATUS_CHANGE',
  OFFER_STATUS_SUCCESS  = 'OFFER_STATUS_SUCCESS',
  OFFER_STATUS_FAILURE  = 'OFFER_STATUS_FAILURE',
  REQUEST = 'REQUEST',
  REQUEST_SUCCESS  = 'REQUEST_SUCCESS',
  REQUEST_FAILURE  = 'REQUEST_FAILURE'
}

export class ViewOffer implements Action {
  readonly type = OfferActionTypes.VIEW_OFFER;
  constructor(public id:number,public payload: any) {}
}
export class Request implements Action {
  readonly type = OfferActionTypes.REQUEST;
  constructor(public payload: any) {}
}
export class DefaultOfferState implements Action {
  readonly type = OfferActionTypes.DEFAULT_OFFER_STATE;
  constructor(public payload: any) {}
}
export class OfferSuccess implements Action {
  readonly type = OfferActionTypes.OFFER_SUCCESS;
  constructor(public payload: any) {}
}
export class OfferFailure implements Action {
  readonly type = OfferActionTypes.OFFER_FAILURE;
  constructor(public payload: any) {}
}
export class RequestSuccess implements Action {
  readonly type = OfferActionTypes.REQUEST_SUCCESS;
  constructor(public payload: any) {}
}
export class RequestFailure implements Action {
  readonly type = OfferActionTypes.REQUEST_FAILURE;
  constructor(public payload: any) {}
}
export class ChangeOfferStatus implements Action {
  readonly type = OfferActionTypes.OFFER_STATUS_CHANGE;
  constructor(public id:number,public payload: any) {}
}
export class ChangeOfferSuccess implements Action {
  readonly type = OfferActionTypes.OFFER_STATUS_SUCCESS;
  constructor(public payload: any) {}
}
export class ChangeOfferFailure implements Action {
  readonly type = OfferActionTypes.OFFER_STATUS_FAILURE;
  constructor(public payload: any) {}
} 

export type All =
  | ViewOffer
  | OfferSuccess
  | OfferFailure
  | ChangeOfferStatus
  | ChangeOfferSuccess
  | ChangeOfferFailure
  | Request
  | RequestSuccess
  | RequestFailure
  | DefaultOfferState;
